/**
 * @file   src\components\MemberWantAd\NiceToHave\Property.js
 * @brief  This file is responsible for nice to have selection in want ad creation
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React from "react";
import NiceToHaveHelper from "./NiceToHaveHelper";

const Property = (props) => {
  const { properties, itemArray, handleItemClick } = props;
  return (
    <NiceToHaveHelper
      list={properties}
      selectedItems={itemArray}
      propertyClick={handleItemClick}
    />
  );
};
export default Property;
